import { useCallback, useMemo } from "react";
import { Contact, ContactList } from "../firebase/firestore/contacts";
import { useTableSearch } from "./useTableSearch";

export function useFilteredContactLists(contactLists: ContactList[], searchVal) {
  const retrieveFunc = useCallback(
    () => ({
      data:
        contactLists?.map((c) => {
          return c;
        }) || [],
    }),
    [contactLists]
  );

  const { filteredData, loading } = useTableSearch({
    searchVal,
    retrieve: retrieveFunc,
  });

  const sortedFilteredLists = useMemo<Contact[]>(
    () => filteredData.sort((a, b) => b.date_created - a.date_created),
    [filteredData]
  );

  return { sortedFilteredLists, loading };
}

